import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@syneto/compass-react';

export const HideBannerModal = (props) => {
	const { show, submitting, onHide, onConfirm } = props;

	return (
		<Modal
			show={show}
			onHide={onHide}
			title="Hide this banner?"
			content="You can always manage your Partner Preview Program access from the Inventory page."
			actions={{
				primary: {
					label: 'Hide banner',
					onClick: onConfirm,
					disabled: submitting,
				},
				secondary: {
					label: 'Cancel',
					onClick: onHide,
				},
			}}
		/>
	);
};

HideBannerModal.propTypes = {
	show: PropTypes.bool.isRequired,
	submitting: PropTypes.bool.isRequired,
	onHide: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
};
